<template>
  <header id="admin-page-header">
    <blockquote>
      <h3 style="display: inline;">{{ title }}</h3>
      <slot name="admin-header-slot"></slot>
    </blockquote>
    <section id="admin-common-ops" class="clearfix">
      <div class="col-xs-12 col-md-6" id="admin-buttons">
        <slot name="buttons"></slot>
        <div class="btn btn-success sq"  @click="$emit('create-entity-request')" v-if="showNewButton">
          New <i class="fa fa-plus"></i>
        </div>
        <div class="btn btn-primary sq"  @click="$emit('open-filter')">
          Filter <i class="fa fa-filter"></i>
        </div>
        <!--
        <div class="btn btn-info sq" v-if="uploader" >
          Upload <i class="fa fa-upload"></i>
        </div>
        -->
      </div>
      <div class="col-xs-12 col-md-6">
        <form @submit.prevent="emitSearch">
          <div class="input-group">
            <input :disabled="disableQuickSearch" type="text" :placeholder="searchPlaceholder" class="form-control" id="admin-filter-search" v-model="search"/>
            <span :class="[ disableQuickSearch ? 'disabled' : '', 'input-group-addon']" @click="emitSearch">
              <i class="fa fa-search"></i>
            </span>
            <input type="submit" style="display:none;"/>
          </div>
        </form>
      </div>
    </section>
  </header>
</template>
<script>
  import event from '../../../event.js'
  import ParseToJson from '../../helpers/ParseToJson.vue'
  export default {
    name: 'AdminHeader',
    props: {
      title: {
        type: String
      },
      uploader: {
        type: Boolean
      },
      showNewButton: {
        type: Boolean,
        default: true
      },
      disableQuickSearch: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        search: ''
      }
    },
    components: {
      ParseToJson
    },
    computed: {
      searchPlaceholder () {
        return this.disableQuickSearch ? 'Please use the filter menu to search.' : 'Search'
      }
    },
    methods: {
      emitSearch () {
        if (!this.disableQuickSearch) {
          let search = `%25${this.search || ''}%25`
          this.$emit('entity-quick-search', { search })
        } else {
          event.$emit('toast', { type: 'warning', message: 'Please use the filter menu to search.' })
        }
      },
      parse () {
        event.$emit('loading-on', { title: 'Parsing CSV' })
      },
      upload (data) {
        event.$emit('loading-off', {})
        this.$emit('csv-upload', data)
      }
    }
  }
</script>

<style scoped>
  #admin-page-header {
    padding: 10px;
  }
  #admin-common-ops {
    background-color: #eee;
    padding: 10px;
  }
  span.disabled {
    background-color: #eee;
  }
  span.disabled i {
    cursor: not-allowed;
  }
  @media (max-width: 992px) {
    #admin-buttons > * {
      width: 49%;
    }
    #admin-buttons {
      margin-bottom: 5px;
      display: flex;
      justify-content: space-around;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/AdminHeader.vue